import {
    FTP_DISCLAIMER_COMPACT,
    FTP_DISCLAIMER_SHORT,
} from "../../utils/virtualCurrencyDisclaimer";

type FtpDisclaimerProps = {
    /** `short` = full Meta line; `compact` = bullet-style eyebrow. */
    variant?: "short" | "compact";
    /** Override default copy (e.g. signup/login popup footer). */
    text?: string;
    className?: string;
};

const DEFAULT_CLASS =
    "font-chakra text-[11px] font-normal leading-snug tracking-normal normal-case sm:text-[12px]";

/** Shared free-to-play / no-cash-value disclaimer for wallets, modals, and lobbies. */
export function FtpDisclaimer({ variant = "short", text, className = "" }: FtpDisclaimerProps) {
    const defaultText = variant === "compact" ? FTP_DISCLAIMER_COMPACT : FTP_DISCLAIMER_SHORT;
    const displayText = text ?? defaultText;
    const alignmentClass = /\btext-(left|right|center|start|end)\b/.test(className)
        ? ""
        : "text-center";
    const colorClass = /\btext-/.test(className) ? "" : "text-white/55";
    return (
        <p className={`${DEFAULT_CLASS} ${colorClass} ${alignmentClass} ${className}`.trim()}>
            {displayText}
        </p>
    );
}
